import styles from './BottomCard.module.scss';
import parse from 'html-react-parser';
import classNames from 'classnames';
export interface IBottomCard {
  number: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  buttonComponent: JSX.Element;
  palette?: 'default' | 'sport'; //default or sport
}
const BottomCard = ({
  number,
  title,
  subtitle,
  description,
  buttonComponent,
  image,
  palette = 'default',
}: IBottomCard) => {
  return (
    <>
      <div
        className={classNames('d-fl fd-c ai-c jc-sb', styles.bottom_card, {
          [styles.bottom_card_sport]: palette == 'sport',
          [styles.bottom_card_default]: palette != 'sport',
        })}
      >
        <div className={styles.top_container}>
          <div className={styles.title_container}>
            {number != null ? (
              <div className={`${styles.number_container} d-fl ai-c jc-c`}>
                <p>{number}</p>
              </div>
            ) : null}
            <p className={styles.title}>{title}</p>
          </div>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        <div className={`d-fl ai-c jc-c fd-c ${styles.image_container}`}>
          <img src={image} alt="" />
          <p className={styles.description}>{parse(description)}</p>
          <div className={`${styles.button_container} d-fl ai-c jc-c`}>{buttonComponent}</div>
        </div>
      </div>
    </>
  );
};
export default BottomCard;
